jQuery(($) => {
    $('.o-product-gallery-hero__gallery-image-wrapper').on('click', function () {
        $(this).parent().toggleClass('zoomed');
    });

    $('.o-product-gallery-hero__gallery-item').on('mousemove', function (e) {
        if ($(this).hasClass('zoomed')) {
            let offsetX = e.offsetX;
            let offsetY = e.offsetY;
            let width = $(this).width();
            let height = $(this).height();

            // Calculate the background position based on mouse position
            let backgroundPosX = (offsetX / width) * 100;
            let backgroundPosY = (offsetY / height) * 100;

            $(this).find('.o-product-gallery-hero__gallery-image-zoom').css({
                'background-position': `${backgroundPosX}% ${backgroundPosY}%`
            });
        }
    });

    $('.o-product-gallery-hero__gallery-item').on('mouseleave', function () {
        if ($(this).hasClass('zoomed')) {
            $(this).removeClass('zoomed');
        }
    });

    $('#pa_color').on('change', function () {
        let selectedColor = $(this).val();

        $('.o-product-gallery-hero__variation-image-wrapper').each(function () {
            let itemColor = $(this).attr('data-variation-name');

            if (selectedColor === itemColor) {
                $(this).addClass('o-product-gallery-hero__variation-image-wrapper--active');
            } else {
                $(this).removeClass('o-product-gallery-hero__variation-image-wrapper--active');
            }
        });

        $('.m-product-gallery-slider__primary-slider').slick('refresh');
    });

    $('form.variations_form').on('woocommerce_variation_select_change', function () {
        $(this).addClass('show-variation-price');
        $('.o-product-gallery-hero__preload-variation-price').hide();
    });
}); 